<script setup>
import { ref } from "vue";

defineProps({
  icon: { type: String, default: "mdi-account-cancel" },
  dialogIcon: { type: String, default: "mdi-delete" },
  title: { type: String, default: "Are you sure?" },
  text: { type: String, default: "This entity will be deactivated." },
  confirmText: { type: String, default: "Ok" },
  cancelText: { type: String, default: "Cancel" },
  color: { type: String, default: "warning" },
  confirmColor: { type: String, default: "error" },
  size: { type: String, default: "small" },
  iconClasses: { type: String, default: "" },
});

const emit = defineEmits(["confirm"]);

const dialog = ref(false);

const toggleDialog = () => {
  dialog.value = !dialog.value;
};
</script>

<template>
  <v-btn
    :color="color"
    style="
      border-radius: 0;
      background-color: none !important;
      padding: 0px !important;
    "
    :class="iconClasses"
    variant="text"
    :icon="icon"
    :size="size"
    @click="toggleDialog"
  />

  <v-dialog v-model="dialog" width="auto">
    <v-card
      max-width="400"
      :prepend-icon="dialogIcon"
      :title="title"
      :text="text"
    >
      <template #actions>
        <v-btn
          class="ms-auto"
          :text="confirmText"
          :color="confirmColor"
          @click="
            () => {
              emit('confirm');
              toggleDialog();
            }
          "
        />
        <v-btn class="ms-auto" :text="cancelText" @click="toggleDialog" />
      </template>
    </v-card>
  </v-dialog>
</template>
